import twMessages from '../locales/zh-Hant.json';

const TwLang = {
  messages: {
    ...twMessages,
  },
  locale: 'zh-Hant-TW',
};
export default TwLang;
